import { storeProfilesNode } from '@/api/firebase'
import { firebaseObjectToArray, firebaseObjectWithId } from '@/utils'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'
import { STORE_PROFILES } from 'db'

// Stores must be persisted, so fetch by field results should set on searchStoreProfiles
const state = {
    storeProfiles: false,
    storeProfile: false,
    ...async()
}

const getters = {
    GET_STORE_PROFILES: (state) => firebaseObjectToArray(state.storeProfiles),
    GET_STORE_PROFILE: (state) => firebaseObjectWithId(state.storeProfile),
    GET_ASYNC
}

const mutations = {
    SET_STORE_PROFILES(state, payload) {
        state.storeProfiles = payload
    },
    SET_STORE_PROFILE(state, payload) {
        state.storeProfile = payload
    },
    CLEAR_STORE_PROFILES(state) {
        state.storeProfiles = false
    },
    CLEAR_STORE_PROFILE(state) {
        state.storeProfile = false
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================

    // =================================== Read Operations ===================================

    /**
     * FETCH_STORE_PROFILES
     *
     *     Retrieve a list of storeProfiles and set data in vuex state if not already set.
     *     If empty, set null. Binds a firebase connection.
     *
     * @returns {Void}
     */
    FETCH_STORE_PROFILES({ commit, state }) {
        if (!state.storeProfiles) {
            commit('REQUEST')
            commit('CLEAR_STORE_PROFILES')
            storeProfilesNode.on(
                'value',
                function(data) {
                    try {
                        commit('SET_STORE_PROFILES', data.val())
                        commit('SUCCESS')
                    } catch (err) {
                        commit('ERROR', err.message)
                    }
                },
                function(err) {
                    commit('ERROR', err.message)
                }
            )
        }
    },

    /**
     * FETCH_STORE_PROFILE_BY_ID
     *
     *     Retrieve a storeProfile by id. If empty, set false. Binds a firebase connection.
     *
     * @param payload.id {string} - The id of the store to retrieve.
     * @returns {Void}
     */
    FETCH_STORE_PROFILE_BY_ID({ commit }, payload) {
        commit('REQUEST')
        commit('CLEAR_STORE_PROFILE')
        storeProfilesNode.child(payload.id).on(
            'value',
            function(data) {
                try {
                    commit('SET_STORE_PROFILE', data.val() ? { ...data.val(), id: payload.id } : false)
                    commit('SUCCESS')
                } catch (err) {
                    commit('ERROR', err.message)
                }
            },
            function(err) {
                commit('ERROR', err.message)
            }
        )
    },

    /**
     * FETCH_STORE_NAME_ONCE
     *
     *     Retrieve a the name of a store in storeProfile.
     *     If empty, return null. Does not bind a firebase connection.
     *
     * @param payload.id {string} - The id of the store to fetch.
     * @returns {String}
     */
    async FETCH_STORE_NAME_ONCE(_, payload) {
        const data = await storeProfilesNode
            .child(payload.id)
            .child(STORE_PROFILES.fields.name)
            .once('value')
        return data.val()
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_STORE_PROFILES_REFERENCE
     *
     *     Unbind a firebase connection that was set.
     */
    REMOVE_STORE_PROFILES_REFERENCE({ commit }) {
        commit('CLEAR')
        commit('CLEAR_STORE_PROFILES')
        storeProfilesNode.off()
    },

    /**
     * REMOVE_STORE_PROFILE_REFERENCE
     *
     *     Unbind a firebase connection on a child that was set.
     *
     * @param payload.id {string} - The id of the storeProfile child.
     */
    REMOVE_STORE_PROFILE_REFERENCE({ commit }, payload) {
        commit('CLEAR')
        commit('CLEAR_STORE_PROFILE')
        storeProfilesNode.child(payload.id).off()
    }
}

export { state, getters, mutations, actions }
